import "../scss/newsletter-principessa.scss"

import { isDev } from "@/utils/enviroment-detector"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import type { InfoClienteAppProps, InfoClienteProps } from "./info-cliente.props"

export function InfoClientePrincipessa({ configuracaoLayout }: Readonly<InfoClienteProps>) {
    return (
       <div className="avisos-container container">
            {configuracaoLayout.tempoChatOnline && (
                <div className="item-container">
                    <div className="item-info">
                        <div className="icon icon-chat"></div>
                        <span>{configuracaoLayout.tempoChatOnline}</span>
                    </div>
                </div>
            )}

            {configuracaoLayout.valorFrete && (
                <div className="item-container">
                    <div className="item-info">
                        <div className="icon icon-truck"></div>
                        {configuracaoLayout.valorFrete}
                    </div>
                </div>
            )}

            {configuracaoLayout.diasTrocas && (
                <div className="item-container">
                    <div className="item-info">
                        <div className="icon icon-calendar">
                            <img
                                className="lazyload lazyload-svg"
                                src={isDev() ? getResourceFromS3('assets/global/blog', 'icon-calendar.svg') : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                data-src={getResourceFromS3('assets/global/blog', 'icon-calendar.svg')}
                                width="14"
                                height="14"
                                alt="Calendário"
                                title="Calendário"
                            />
                        </div>
                        <span>{configuracaoLayout.diasTrocas}</span>
                    </div>
                </div>
            )}

            {configuracaoLayout.parcelamentoRodape && (
                <div className="item-container">
                    <div className="item-info">
                        <div className="icon icon-card"></div>
                        <span>{configuracaoLayout.parcelamentoRodape}</span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default class InfoClientePrincipessaApp {
    constructor(props: InfoClienteAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<InfoClientePrincipessa {...props} />)
    }
}